module.exports = __webpack_public_path__ + "static/media/MANA-101-badge.b84598e3.svg";